<template>
  <div
    :class="classNames"
    @click="close()"
    data-html2canvas-ignore="true">
  </div>
</template>

<script>
import {
  SET_TEMPORARY_VIEW_VISIBILITY } from '../modules/mutation-types'
export default {
  name: 'CMObfuscator',
  props: {
    backdrop: {
      default: 'static'
    }
  },
  computed: {
    classNames () {
      let obj = {
        'cm-layout__obfuscator': true
      }
      obj[`is-visible`] = this.visibility
      return obj
    },
    hasTemporaryDrawer () {
      let state = this.$store.state
      return state.device.sizeClass === 'compact' &&
      state.app.drawer.visibility === 'visible'
    },
    visibility () {
      return this.$store.state.app.temporaryView || this.hasTemporaryDrawer
    }
  },
  methods: {
    close () {
      this.$emit('close')
      if (this.backdrop === 'active') {
        this.$store.commit(SET_TEMPORARY_VIEW_VISIBILITY, null)
      }
    }
  },
  mounted () {
    document.onkeydown = (evt) => {
      evt = evt || window.event
      if (this.visibility === 'visible' && (('key' in evt) ? (evt.key === 'Escape' || evt.key === 'Esc') : (evt.keyCode === 27))) {
        this.close()
      }
    }
  }
}
</script>

<style lang="sass">
  .cm-layout__obfuscator
    background-color: rgba(37, 40, 43, 0.6)
    opacity: 0
    // visibility: hidden
    pointer-events: none
    position: fixed
    height: 100%
    width: 100%
    z-index: 1200
    transition: opacity 200ms linear
  .cm-layout__obfuscator.is-visible
    pointer-events: auto
    // visibility: visible
    opacity: 1
</style>



// WEBPACK FOOTER //
// src/components/CMObfuscator.vue